module.exports = __webpack_public_path__ + "static/images/startPages04.b849d98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/haoLian/startPages04.png
// module id = nWNK
// module chunks = 0